var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInTransit = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15.125,
    viewBox: "0 0 22 15.125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b548c6",
    d: "M0 6v1.375h13.063v10.313H8.83a2.724 2.724 0 0 0-5.285 0H2.75V14.25H1.375v4.813h2.17a2.724 2.724 0 0 0 5.285 0h5.715a2.724 2.724 0 0 0 5.285 0H22v-5.608l-.043-.107-1.375-4.125-.15-.473h-5.994V6zm.688 2.75v1.375h6.187V8.75zm13.75 1.375h5.006l1.182 3.523v4.039h-.796a2.724 2.724 0 0 0-5.285 0h-.107zM1.375 11.5v1.375H5.5V11.5zM6.188 17a1.375 1.375 0 1 1-1.375 1.375A1.364 1.364 0 0 1 6.188 17zm11 0a1.375 1.375 0 1 1-1.375 1.375A1.364 1.364 0 0 1 17.188 17z",
    transform: "translate(0 -6)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInTransit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/in_transit.b8efbbdb.svg";
export { ForwardRef as ReactComponent };